import { all, call, spawn } from 'redux-saga/effects';
import { larvaSmartHomeWatcher } from 'smartHome/larva/saga/watchers';
import { messagingWatchers } from 'messaging/saga/watchers';
import { firebaseWatchers } from '../../firebase/saga/watchers';

export function* rootSaga(): Generator {
    const sagas = [larvaSmartHomeWatcher, messagingWatchers, firebaseWatchers];

    yield all(
        sagas.map((saga) =>
            spawn(function* () {
                while (true) {
                    try {
                        yield call(saga);
                        break;
                    } catch (reason) {
                        console.error(`Failed saga: ${saga?.name}`, reason);
                    }
                }
            }),
        ),
    );
}
